import classNames from 'classnames';
import { ForwardedRef } from 'react';

import BasicButton, { BasicButtonElement, BasicButtonProps } from './BasicButton';

import styles from '../../styles/buttons/urbania-button.module.css';

import urbaniaLogo from '../../assets/img/brands/urbania_logo.svg';

function UrbaniaButton({
    className = null,
    href = '/',
    ref: buttonRef = null,
    ...props
}: BasicButtonProps & { ref?: ForwardedRef<BasicButtonElement> | null }) {
    return (
        <BasicButton
            ref={buttonRef}
            className={classNames([styles.container, className])}
            href={href}
            {...props}
        >
            <img src={urbaniaLogo} alt="Urbania" className={styles.logo} />
        </BasicButton>
    );
}

export default UrbaniaButton;
